import {
  TranslocoModule,
  TRANSLOCO_CONFIG,
  TRANSLOCO_LOADER,
  TRANSLOCO_TRANSPILER,
  translocoConfig,
  TranslocoConfig,
} from '@ngneat/transloco';
import { MessageFormatTranspiler } from '@ngneat/transloco-messageformat';

import { NgModule, ModuleWithProviders, InjectionToken } from '@angular/core';

import { LOCALE_SERVICE } from '@lib/common/pipes/format-date.pipe';

import {
  FsDistancePipe,
  FsNumberPipe,
  FsSpeedPipe,
  FsTemperaturePipe,
  TranslationPipe,
} from './pipes';
import { LocaleService } from './services/locale.service';
import { TranslocoHttpLoader } from './utilities/transloco-loader';

export interface TranslationModuleConfig {
  availableLangs: string[];
  defaultLang?: string;
  fallbackLang?: string;
  reRenderOnLangChange?: boolean;
  prodMode?: boolean;
  logMissingKey?: boolean;
}

export const TRANSLATION_CONFIG = new InjectionToken<TranslationModuleConfig>('TRANSLATION_CONFIG');

@NgModule({
  imports: [TranslocoModule],
  exports: [
    TranslocoModule,
    TranslationPipe,
    FsNumberPipe,
    FsTemperaturePipe,
    FsSpeedPipe,
    FsDistancePipe,
  ],
  declarations: [TranslationPipe, FsNumberPipe, FsTemperaturePipe, FsSpeedPipe, FsDistancePipe],
})
export class TranslationModule {
  static forRoot(config: TranslationModuleConfig): ModuleWithProviders<TranslationModule> {
    return {
      ngModule: TranslationModule,
      providers: [
        {
          provide: TRANSLATION_CONFIG,
          useValue: config,
        },
        {
          provide: TRANSLOCO_CONFIG,
          useFactory: (translationConfig: TranslationModuleConfig): TranslocoConfig => {
            return translocoConfig({
              availableLangs: translationConfig.availableLangs,
              defaultLang: translationConfig.defaultLang || 'en-US',
              fallbackLang: translationConfig.fallbackLang || 'en-US',
              reRenderOnLangChange: translationConfig.reRenderOnLangChange ?? true,
              prodMode: translationConfig.prodMode ?? false,
              missingHandler: {
                useFallbackTranslation: true,
                // TODO: https://taserintl.atlassian.net/browse/FWX-2794
                // Remove logMissingKey after the i18n Phase 1 release
                logMissingKey: translationConfig.logMissingKey ?? false,
              },
            });
          },
          deps: [TRANSLATION_CONFIG],
        },
        {
          provide: TRANSLOCO_LOADER,
          useClass: TranslocoHttpLoader,
        },
        {
          // Allows for pluralization of translations
          provide: TRANSLOCO_TRANSPILER,
          useClass: MessageFormatTranspiler,
        },
        {
          provide: LOCALE_SERVICE,
          useExisting: LocaleService,
        },
      ],
    };
  }
}
